import React from "react";
import LegalPage from "./LegalPage";

const SECTIONS = [
  {
    heading: "1. Agreement to these terms",
    body: [
      'These Terms of Service ("Terms") are a legal agreement between you and KARM LLC ' +
      '("KARM," "we," "us"). By creating an account or using the KARM Safety application ' +
      '("Service"), you agree to be bound by these Terms. If you do not agree, do not use the Service.',
    ],
  },
  {
    heading: "2. Who can use the service",
    body: [
      'You must be at least 16 years old and legally capable of entering a binding contract. If you use the Service on behalf of a company, you represent that you have the authority to bind that company to these Terms.',
    ],
  },
  {
    heading: "3. Your account",
    body: [
      'You are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your account. Notify us immediately at shane@karmsafety.com if you suspect unauthorized access. We are not liable for losses caused by unauthorized use of your account when you failed to take reasonable steps to protect your credentials.',
    ],
  },
  {
    heading: "4. Acceptable use",
    body: [
      'You agree not to:',
      { items: [
        "Use the Service for any unlawful purpose or in violation of any applicable regulation.",
        "Upload content you do not have permission to store or share.",
        "Interfere with, disrupt, or attempt to gain unauthorized access to the Service or its infrastructure.",
        "Reverse engineer, decompile, or attempt to extract source code from the Service.",
        "Use the Service to send spam, phishing attempts, or malicious content.",
        "Impersonate another person or misrepresent your affiliation with any company.",
      ]},
      'We may suspend or terminate accounts that violate this section without prior notice.',
    ],
  },
  {
    heading: "5. Your content",
    body: [
      'You retain ownership of all data you upload — roster records, certifications, photographs, and job site information ("Your Content"). You grant KARM a limited license to store, process, and display Your Content solely for the purpose of operating the Service on your behalf.',
      'You represent that you have all necessary rights to upload Your Content, including consent from any individual whose personal information appears in it (e.g., employees whose certifications you record).',
    ],
  },
  {
    heading: "6. Fees",
    body: [
      'The Service is currently offered free of charge or on a subscription basis as displayed in-app. If we introduce or change fees, we will give you at least thirty (30) days notice by email. Fees are non-refundable except where required by law.',
    ],
  },
  {
    heading: "7. Third-party services",
    body: [
      'The Service integrates with third-party providers (email delivery, cloud storage, push notifications). We are not responsible for the acts, omissions, or content of third parties. Your use of those services is governed by their own terms and privacy policies.',
    ],
  },
  {
    heading: "8. Intellectual property",
    body: [
      'The Service, including its design, code, branding, and content (excluding Your Content), is owned by KARM LLC and is protected by copyright, trademark, and other intellectual property laws. We grant you a limited, non-exclusive, non-transferable license to use the Service in accordance with these Terms.',
    ],
  },
  {
    heading: "9. Disclaimers",
    body: [
      'THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT ALL DEFECTS WILL BE CORRECTED.',
      'KARM SAFETY IS A TOOL FOR TRACKING CERTIFICATIONS. IT IS NOT A SUBSTITUTE FOR PROFESSIONAL SAFETY, LEGAL, OR COMPLIANCE ADVICE. YOU ARE SOLELY RESPONSIBLE FOR ENSURING YOUR COMPLIANCE WITH OSHA AND OTHER APPLICABLE REGULATIONS.',
    ],
  },
  {
    heading: "10. Limitation of liability",
    body: [
      'TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL KARM LLC, ITS OFFICERS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR BUSINESS OPPORTUNITIES, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.',
      'OUR AGGREGATE LIABILITY FOR ANY CLAIM ARISING FROM THESE TERMS OR THE SERVICE SHALL NOT EXCEED THE GREATER OF (A) ONE HUNDRED U.S. DOLLARS ($100) OR (B) THE AMOUNT YOU PAID US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.',
    ],
  },
  {
    heading: "11. Indemnification",
    body: [
      'You agree to indemnify and hold harmless KARM LLC from any claims, damages, or expenses (including reasonable attorneys\' fees) arising from Your Content, your use of the Service in violation of these Terms, or your violation of any law or third-party right.',
    ],
  },
  {
    heading: "12. Termination",
    body: [
      'You may stop using the Service at any time by contacting shane@karmsafety.com. We may suspend or terminate your account at any time if you violate these Terms, if required by law, or if we discontinue the Service. Upon termination, provisions that by their nature should survive (ownership, disclaimers, limitations of liability, indemnity) will continue to apply.',
    ],
  },
  {
    heading: "13. Governing law and disputes",
    body: [
      'These Terms are governed by the laws of the United States and the state in which KARM LLC is registered, without regard to conflict-of-law rules. Any dispute arising from these Terms shall be resolved through binding arbitration on an individual basis, except that either party may bring a claim in small-claims court. You waive the right to participate in a class action.',
    ],
  },
  {
    heading: "14. Changes to these terms",
    body: [
      'We may update these Terms from time to time. Material changes will be announced in-app or via email at least seven (7) days before they take effect. Continued use of the Service after the effective date constitutes acceptance.',
    ],
  },
  {
    heading: "15. Contact",
    body: [
      'Questions about these Terms: KARM LLC — shane@karmsafety.com',
    ],
  },
];

export default function Terms() {
  return <LegalPage title="Terms of Service" effectiveDate="July 9, 2026" sections={SECTIONS} />;
}
